export default "__VITE_ASSET__8HDoVXWK__"